import { useData } from "@hooks/useData";
import http from "@core/fetch";
import { ID } from "@datassential/platform-ui-lib";
import dayjs from "dayjs";

export interface IMacItem {
    id: ID;
    documentType: ID;
    publicationFamily: string;
    title: string;
    description: {
        preview: string;
        additional: string;
    };
    countryCodeStr: string;
    itemsCount: number;
    shareLink: string;
    dateStr: string;
    dateSort: Date;
    downloadLinks: Array<{
        fileExtension: string;
        url: string;
    }>;
    thumbnailUrl: string;
}

type ApiMacItemModel = {
    id: ID;
    dateTime: string
    description: string;
    documentType: ID;
    publicationFamily: string;
    downloadLinks: Array<{
        fileExtension: "ppt" | "jpeg";
        linkToDownload: string;
        title: string;
    }>;
    generateLink: string;
    modifiedDate: string;
    shareLinkString: string;
    nonUS: boolean;
    title: "Canadian new kombucha MAC";
    thumnailUrl: string;
};

function getMacWords(rawDescription: string): string[] {
    const rawList = rawDescription.split('<');

    return rawList.map((elem) => elem.split('|')[0].trim());
}

function getMacDescription(words: string[]) {
    const SHORT_WORDS_COUNT = 2;
    
    return {
        preview: words.length > 0 ? `includes ${words.slice(0, SHORT_WORDS_COUNT).join(', ')}` : '',
        additional: words.slice(SHORT_WORDS_COUNT).join(', ')
    };
}

type ApiModel = Array<{
    items: ApiMacItemModel[];
}>;

async function getMacsList(): Promise<IMacItem[]> {
    const response: ApiModel = await http.get('documents', {
        doctype: 'Mac',
        skip: 0,
        take: 1000,
        word: '',
        t: Date.now(),
    });

    try {
        return response[0].items.map((item) => {
            const words = getMacWords(item.description);

            return ({
                id: item.id,
                title: item.title,
                description: getMacDescription(words),
                countryCodeStr: item.nonUS ? 'CAN' : 'USA',
                itemsCount: words.length,
                shareLink: item.shareLinkString,
                downloadLinks: [
                    {
                        fileExtension: 'PPT',
                        url: item.downloadLinks[1]?.linkToDownload,
                    },
                    {
                        fileExtension: 'PNG',
                        url: item.downloadLinks[3]?.linkToDownload,
                    },
                ],
                dateStr: dayjs(item.modifiedDate).format('MM/DD/YYYY'),
                dateSort: new Date(item.modifiedDate),
                documentType: item.documentType,
                publicationFamily: item.publicationFamily,
                thumbnailUrl: item.thumnailUrl,
            })
    });
    }
    catch (e) {
        console.error(e);
        return [];
    }
}

export function useMacsList () {
    return useData([], getMacsList)
}